import { UseFormReturn } from "react-hook-form";
import { ProjectViewFormData } from "./schema";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Upload, X } from "lucide-react";
import { useState } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/class-control";
import { useUploadImage } from "@/services/queries/useProject";

export function ProjectCoverForm({ form }: { form: UseFormReturn<ProjectViewFormData> }) {

  const { mutateAsync: uploadImage } = useUploadImage();

  const handleFileUpload = async (file: File | null) => {
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('file', file);

      return await uploadImage({
        data: formData
      });
    } catch (error) {
      console.error('Erro ao fazer upload do documento:', error);
    }
  };

  const CoverImageUpload = () => {
    const [preview, setPreview] = useState<string | null>(localStorage.getItem("coverImage") || null);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        console.log('file', file)
        await handleFileUpload(file)

        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result as string);
          localStorage.setItem("coverImage", reader.result as string);
        };
        reader.readAsDataURL(file);
        form.setValue("coverImage", file);
      }
    };

    const removeImage = () => {
      setPreview(null);
      localStorage.removeItem("coverImage")
      form.setValue("coverImage", null);
    };

    return (
      <FormField
        control={form.control}
        name="coverImage"
        render={({ field }) => (
          <FormItem className={cn("border-2 border-gray-600 border-dashed rounded-md", 
            preview === null ? "p-10" : "p-2"
          )}>
            <FormLabel className="text-white"></FormLabel>
            <FormControl>
              <div className="flex items-center gap-4">
                {preview && (
                  <div className="relative">
                    <div className="w-72 h-24 rounded overflow-hidden bg-gray-600 flex items-center justify-center">
                      <img src={preview} alt="Preview" className="w-full h-full object-cover" />
                    </div>
                    <button
                      type="button"
                      onClick={removeImage}
                      className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                )}
                {preview === null &&
                  <div className="flex items-center gap-2">
                    <label className="cursor-pointer bg-gray-50 w-8 h-8 hover:bg-gray-200 text-blue-700 rounded-full text-sm flex items-center justify-center gap-2">
                      <Upload className="w-4 h-4" />
                      <input
                        ref={field.ref}
                        name={field.name}
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                      />
                    </label>

                    <div className="flex flex-col items-start">
                      <span className="text-xs font-medium text-white">
                        Imagem de Capa (1920x1080)
                      </span>
                      <span className="text-xs text-gray-400">Clique para trocar seu arquivo</span>
                    </div>
                  </div>}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  };

  return (
    <div className="space-y-8">
      <div className="lg:flex items-center gap-6">
        {/* CAPA DO PROJETO */}
        <div className="flex flex-col gap-4">
          <Label className=" text-white">Imagem de Capa</Label>
          <CoverImageUpload />
        </div>
      </div>
    </div>
  );
}